import { selectJBPSettingsActualsSync } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getEffectiveActualsSync, IEffectiveActualsSync } from '../../lib'
import { selectEffectiveCockpitFYear } from '../selectors'

/** Real "today, mapped onto a fiscal quarter" values, scoped to the fiscal year the cockpit is
 *  actually viewing (`selectEffectiveCockpitFYear`) rather than the real current year. */
export const useEffectiveActualsSync = (): IEffectiveActualsSync => {
  const selectedFYear = useSelector(selectEffectiveCockpitFYear)
  const actualsSync = useSelector(selectJBPSettingsActualsSync)

  return useMemo(
    () =>
      getEffectiveActualsSync({
        selectedFYear,
        realFYear: actualsSync.fYearActuals,
        realCurrentFQuarter: actualsSync.fQuarterActuals,
        realFQuarterActualsPercentage: actualsSync.fQuarterActualsPercentage,
      }),
    [
      selectedFYear,
      actualsSync.fYearActuals,
      actualsSync.fQuarterActuals,
      actualsSync.fQuarterActualsPercentage,
    ]
  )
}
